import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

import { useDispatchedActions } from '@web/shared/hooks/use-dispatched-actions.hook'
import type {
  IMarker,
  IMarkerForm,
  IResultMarkers
} from '@web/shared/types/marker.type'

import type { ISpectrumChartPoint } from './types/chart-spectrum.type'

export interface IInitialMarkersState {
  markers: IMarker[]
  isMarkersExpressBarOpen: boolean
  formMarkers: IMarkerForm | null
  markersResults: IResultMarkers[]
  isDragZone: boolean
  activeMarker: IMarker | null
  chartSpectrum: ISpectrumChartPoint[] | null
}

const initialState: IInitialMarkersState = {
  markers: [],
  isMarkersExpressBarOpen: false,
  markersResults: [],
  formMarkers: null,
  isDragZone: false,
  activeMarker: null,
  chartSpectrum: null
}

export const expressMarkersSlice = createSlice({
  name: 'express-markers',
  initialState,
  reducers: {
    setIsMarkersExpressOpen(state, action: PayloadAction<boolean>) {
      state.isMarkersExpressBarOpen = action.payload
    },

    setMarkers(state, action: PayloadAction<IMarker[]>) {
      state.markers = action.payload
    },

    setMarkersResults(state, action: PayloadAction<IResultMarkers>) {
      const foundIndex = state.markersResults.findIndex(
        (result) => result.title === action.payload.title
      )

      if (foundIndex === -1) {
        state.markersResults.push(action.payload)
      } else {
        state.markersResults[foundIndex] = action.payload
      }
    },

    resetMarkersResults(state) {
      state.markersResults = []
      state.isMarkersExpressBarOpen = false
    },

    setFormMarker(state, action: PayloadAction<IMarkerForm>) {
      state.formMarkers = action.payload
    },

    setIsDragZone(state, action: PayloadAction<boolean>) {
      state.isDragZone = action.payload
    },

    setActiveMarker(state, action: PayloadAction<IMarker>) {
      state.activeMarker = action.payload
    },

    setMarkerSpectrum(state, action: PayloadAction<ISpectrumChartPoint[]>) {
      state.chartSpectrum = action.payload
    },

    resetMarkers(state) {
      state.chartSpectrum = null
      state.activeMarker = null
      state.formMarkers = null
      state.markersResults = []
    }
  }
})

export const expressMarkersReducer = expressMarkersSlice.reducer
export const useExpressMarkersActions = () =>
  useDispatchedActions(expressMarkersSlice.actions)
